import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-delete-membership-plans',
  templateUrl: './delete-membership-plans.component.html',
  styleUrls: ['./delete-membership-plans.component.scss']
})
export class DeleteMembershipPlansComponent implements OnInit {

 //#region Fields
 public membershipPlanId: string;
 //#endregion
 //#region Constructor
 constructor(
   private ref: DynamicDialogRef,
   private config: DynamicDialogConfig
 ) {
   if (this.config.data != undefined && this.config.data.id) {
     this.membershipPlanId = this.config.data.membershipPlanId
   }
 }

 ngOnInit(): void {
 }
 //#endregion
 //#region Public Methods
 deleteMembershipPlan() {

 }
 cancel() {
   this.ref.close(true)
 }
 //#endregion
 //#Private Methods
 //#endregion

}
